import LinkedIn from './LinkedIn'

export default LinkedIn
// eslint-disable-next-line import/export
export * from './LinkedIn'
